import type { IImageBySizes } from '@app/common';

// Module feuille (aucun import de feature) : les helpers de formulaire en dépendent
// sans recréer de cycle avec `valeurs-de-copie.ts`.

// `copieDe` : id de l'original ; `copieDesImagesDe` : l'original dont le
// serveur recopie les images si l'utilisateur n'en choisit pas de nouvelle ;
// `imagesDeLOriginal` : simple aperçu côté formulaire.
export type ValeursDeCopie<T> = T & {
  copieDe: string;
  copieDesImagesDe?: string;
  imagesDeLOriginal?: IImageBySizes;
};

// Clés qui servent au panneau de création mais ne partent pas au serveur.
export const CLES_PRIVEES_DE_COPIE = ['copieDe', 'imagesDeLOriginal'] as const;

export const sansLesClesPriveesDeCopie = <T>(valeurs: T): T => {
  const copie = { ...valeurs } as Record<string, unknown>;
  CLES_PRIVEES_DE_COPIE.forEach((cle) => delete copie[cle]);
  return copie as T;
};
